var App = App || {};

App.SiteSpeedbump = (function ($) {
    'use strict';

    var exemptList = Speedbump.ExemptList,
        uriSchemes = ['javascript:', 'mailto:', 'tel:'];

    function init() {
        SpeedbumpTriggers($("a"));
    }

    ////////////////////////////////////////////////////////////////////////////
    // MODAL TRIGGERS
    ////////////////////////////////////////////////////////////////////////////
    function SpeedbumpTriggers(selector) {
        selector.on("click", function (e) {

            var url = $(this).attr("href");

            if (this.hostname !== location.hostname
                && $.inArray(this.hostname, exemptList) === -1
                && url
                && url.indexOf("#") !== 0
                && !isUriSchema(url)) {

                e.preventDefault();
                SpeedbumpModal(url);
            }
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // SEPARATE SPEEDBUMP FUNCTIONALITY TO USE ELSEWHERE (like locations)
    ////////////////////////////////////////////////////////////////////////////
    function SpeedbumpModal(href) {

        var SpeedbumpModal = new bootstrap.Modal(document.getElementById('speedbump-modal'), {
            keyboard: false
        })

        SpeedbumpModal.show();

        // open third party in new window
        $("#speedbump-modal button[data-bs-proceed='modal']")
            .off("click")
            .on("click", function () {
                SpeedbumpModal.hide();
                window.open(href);
            }
            );
    }

    function isUriSchema(url) {
        for (var i in uriSchemes) {
            if (url.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    return {
        init: init,
        SpeedbumpTriggers: SpeedbumpTriggers,
        SpeedbumpModal: SpeedbumpModal
    };

})(jQuery);

$(function () {
    App.SiteSpeedbump.init();
});